import { TranslatedText } from "@/components/common/text";

export const ModalDisclaimer = ({ text }) => {
    return (
        <div className="mt-2 mb-2 text-xs/[19px] text-cm-p-neutral-dark-500 bg-[#FEFCE8] px-3 py-2 rounded-lg">
            <TranslatedText text={text} />
        </div>
    );
};
